import { render, staticRenderFns } from "./yxtj.vue?vue&type=template&id=6d01919c&scoped=true&"
import script from "./yxtj.vue?vue&type=script&lang=js&"
export * from "./yxtj.vue?vue&type=script&lang=js&"
import style0 from "./yxtj.vue?vue&type=style&index=0&id=6d01919c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d01919c",
  null
  
)

export default component.exports